import React from 'react'
import MainLogoImg from './MainLogoImg'

const Footer = () => {
  return (
    <>
      <div className='min-h-fit w-full p-8 pl-16 mt-32 bg-[#333333] border-t flex justify-start gap-8 text-[#AAAAAA] text-xs '>
        <div className='py-4'>
          <MainLogoImg />
        </div>
        <div className='flex-auto flex flex-col gap-2'>
          <div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet ad natus vero minus
              <br />
              saepe officiis molestias autem laboriosam! Quod ipsum, accusamus voluptatibus eum
              <br />
              voluptatum eaque ea impedit qui possimus alias!
            </p>
          </div>
          <div className='flex gap-2'>
            <p>Email@</p>
            <a href='mailto:andy.lee@givu.us'>andy.lee@givu.us</a>
          </div>
          <p>Copyright 2023. GIVU All rights reserved.</p>
        </div>
      </div>
    </>
  )
}

export default Footer
